(ns common.resource.query.schema
  (:require ["@tanstack/react-query" :as query]
            [cljs-bean.core :refer [->clj]]
            [common.queries :refer [use-query]]
            [common.queries.http :as qhttp]
            [mate.core :as mc]
            [uix.core :as uix :refer [defhook]]
            [uix.re-frame :refer [use-subscribe]]))

(defn schemas-output-structure-query [{:keys [schema-id param advertiser-id]}]
  #js {:enabled (some? schema-id)
       :queryKey #js ["schemas-output-structure" advertiser-id schema-id (hash param)]
       :staleTime js/Infinity
       :queryFn (fn [_ctx]
                  (qhttp/post (qhttp/render :api/schemas-output-structure
                                            {:advertiser-id advertiser-id})
                              {:body {:schema-urn schema-id :param param}}))})

(defn schemas-output-data-query [{:keys [schema-id param advertiser-id]}]
  #js {:enabled (some? schema-id)
       :staleTime js/Infinity
       :queryKey #js ["schemas-output-data" advertiser-id schema-id]
       :queryFn (fn [_ctx]
                  (qhttp/post (qhttp/render :api/schemas-output-data
                                            {:advertiser-id advertiser-id})
                              {:body {:schema-urn schema-id :param param}}))})

(defn schemas-query [{:keys [advertiser-id]}]
  #js {:enabled (some? advertiser-id)
       :staleTime js/Infinity
       :queryKey #js ["schemas" advertiser-id]
       :queryFn (fn [_ctx]
                  (qhttp/get (qhttp/render :api/schemas {:advertiser-id advertiser-id})))})

(defhook use-schema-meta-by-id []
  (let [url-context (use-subscribe [:url-context])
        {schemas :data} (use-query (schemas-query url-context))]
    (uix/use-memo #(mc/index-by :id schemas) [schemas])))

(defn combine-schema-results [schema-ids id->schema-meta results]
  (let [results (->clj results)]
    (when (every? :isSuccess results)
      (->> (->clj results)
           (partition 2)
           (map (fn [schema-id [{output-structure :data} {output-data :data}]]
                  [schema-id
                   {:alias (get-in id->schema-meta [schema-id :alias])
                    :output (merge-with merge output-structure output-data)}])
                schema-ids)
           (into {})))))

(defhook use-schemas [schema-ids]
  (let [url-context (use-subscribe [:url-context])
        id->schema-meta (use-schema-meta-by-id)
        combine-schema-results (uix/use-callback
                                #(combine-schema-results schema-ids id->schema-meta %)
                                [schema-ids id->schema-meta])]
    (query/useQueries
     #js {:queries (->> schema-ids
                        (mapcat
                         (fn [schema-id]
                           (let [query-args (assoc url-context
                                                   :schema-id schema-id)]
                             [(schemas-output-structure-query query-args)
                              (schemas-output-data-query query-args)])))
                        to-array)
          :combine combine-schema-results})))

(defhook use-schema [schema-id]
  (let [schemas (use-schemas [schema-id])]
    (uix/use-memo #(some-> schemas first val ->clj) [schemas schema-id])))
